
<template>
  <vs-popup class="holamundo" popup-class="w-9/12" :title="title" :active.sync="popupActive">
    <form>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            v-validate="'required'"
            label="نام"
            name="name"
            v-model="role1.name"
            class="w-full ltr-input"
          />
          <span class="text-danger text-sm" v-show="errors.has('name')">وارد کردن نام اجباری است</span>
        </div>
        <div class="vx-col w-full">
          <vs-input
            label="عنوان"
            name="displayName"
            v-model="role1.displayName"
            class="w-full"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('displayName')">وارد کردن عنوان اجباری است</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitForm">ذخیره</vs-button>
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
[dir="rtl"] .ltr-datepicker {
  direction: ltr;
}
[dir="rtl"] .ltr-datepicker input {
  border: 1px solid #dadada;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
<script>
import { CreateEditMode } from "@/enums.js";
import { Validator } from "vee-validate";
export default {
  name: "create-or-edit-role",
  props: {},
  components: {},
  data() {
    return {
      popupActive: false,
      createEditMode: CreateEditMode.Create,
      role1: {},
      title: ""
    };
  },
  methods: {
    async submitForm() {
      
      if (!await this.$validator.validateAll()) {
        return;
      }
      let loading = this.$vs.loading();
      let payload = {
        Role: this.role1
      };

      this.$http
        .post("/api/services/app/Role/CreateOrUpdateRoleOnly", this.role1)
        .then(response => {
          if (response.data.success == true) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "نقش با موفقیت ذخیره شد"
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id, name) {
      this.role1 = {};
      if (id) {
        this.createEditMode = CreateEditMode.Edit;
        this.title = 'ویرایش نقش "' + name + '"';
        this.get(id);
      } else {
        this.createEditMode = CreateEditMode.Create;
        this.title = "نقش جدید";
        // this.role1.name='';
        // this.role1.description='';
      }
      this.popupActive = true;
    },
    async get(id) {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          id: id
        }
      };
      this.$http
        .get("/api/services/app/Role/GetRoleForEdit", payload)
        .then(async response => {
          console.log(response.data.result.role);
          this.role1 = response.data.result.role;
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    }
  }
};
</script>